import React from 'react';
import './Login.css';

interface LoginProps {
  onLogin: () => void;
}

export const Login: React.FC<LoginProps> = ({ onLogin }) => {
  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Connect to YNAB</h2>
        <p>
          Connect your You Need A Budget account to view your spendable amounts
          for configured budget categories.
        </p>
        <button onClick={onLogin} className="login-button">
          Connect to YNAB
        </button>
        <div className="login-info">
          <h3>What this app shows:</h3>
          <ul>
            <li>Miscellaneous</li>
            <li>Hair</li>
            <li>Clothing</li>
            <li>Work Snacks</li>
            <li>Takeout</li>
            <li>Health</li>
            <li>Groceries</li>
          </ul>
          <p>
            For each category, you'll see how much money is available to spend
            for the remainder of the month, accounting for scheduled transactions.
          </p>
        </div>
      </div>
    </div>
  );
};
